import * as React from "react";
export const useForceRender = () => {
  const [, setCounter] = React.useState(0);
  return React.useCallback(() => setCounter((prev) => prev + 1), []);
};
